import React, {FunctionComponent} from "react";
import {Layout} from "antd";

export const Content: FunctionComponent = ({children}) => (
  <Layout.Content style={{padding: "0 20px"}}>{children}</Layout.Content>
);
